import "./RemoveNote.scss";

function RemoveNote({ cancelRemoveNote, removeNote }) {
  return (
    <div className="remove-note-content">
      <div className="modal-title">
        <div>Remove Note</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete this note?</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveNote}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeNote}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveNote;
